module.exports = __webpack_public_path__ + "static/media/SmartShop_6-572w.2ac9a360.png";